import styled from "@emotion/styled";
import AccordionSummary from "@mui/material/AccordionSummary";
import { Accordion, AccordionDetails } from "@mui/material";

export const OrderDetailsShipmentAccordionWrapper = styled(Accordion)({
	borderRadius: "0px"
});

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
	padding: "16px",
	backgroundColor: theme.project.colors.backgroundColors.info,
	position: "relative",
	"> span:first-of-type": {
		margin: 0,
		display: "flex",
		alignItems: "center",
		gap: "16px",
		[theme.breakpoints.down("lg")]: {
			flexDirection: "column",
			gap: "8px",
			alignItems: "flex-start"
		}
	},
	svg: {
		color: theme.project.colors.primaryColors.main
	}
}));

export const StyledAccordionDetails = styled(AccordionDetails)({
	display: "flex",
	flexDirection: "column",
	gap: "8px",
	padding: "16px"
});

export const StyledOrderAndShippingIcon = styled.div({
	img: {
		height: 26,
		width: 26
	},
	display: "flex",
	alignItems: "center",
	gap: "16px"
});

export const BackorderAndShipmentTextCount = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	display: "flex",
	color: theme.project.colors.primaryColors.main,
	gap: "16px",
	alignItems: "center",
	"> span:last-of-type": {
		...theme.project.typography.body.body1,
		fontSize: 20
	},
	[theme.breakpoints.down("sm")]: {
		div: {
			margin: 0
		}
	}
}));

export const StyledOrderAndShippingStatusMessage = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	color: theme.project.colors.primaryColors.main,
	...theme.project.typography.subtitle.subtitle2,
	gap: "8px",
	"> span": {
		lineHeight: "20px"
	},
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		alignItems: "flex-start"
	}
}));
